import styled from 'styled-components';

export const Modal = styled.div`
  cursor: initial;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999;
  background-color: rgba(0,0,0, 0.5);
  backdrop-filter: blur(2px);
`; 

export const ButtonClose = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 8px;
`
// export const Button = styled.button`
//   width: 50px;
//   height: 34px;
//   border-radius: 5px;
//   background-color: ${(props) => props.color};

// `
export const Elemento = styled.div`
  position: ${(props) => (props.position ? props.position : '')};
  display: flex;
  flex-direction: ${(props) => (props.direction ? props.direction : 'column')};
  flex-wrap: ${(props) => (props.wrap ? props.wrap : '')};
  margin-bottom: ${(props) => (props.wrap ? props.wrap : '26vh')};
  justify-content: ${(props) => (props.justify ? props.justify : '')};
  align-items: ${(props) => (props.align ? props.align : '')};
  width: ${(props) => (props.width ? props.width : '')};
`;


export const Icon = styled.img`
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  margin: ${(props) => props.margin || '0 10px'};

  :hover {
    cursor: pointer;
  }
`;

export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: ${(props) => props.theme.colors.label};
  transition: color 150ms ease;
  &:hover {
    color: ${(props) => props.theme.colors.lightblue};
  }
`;

export const Messsage = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 300px;

  label {
    color: ${(props) =>
      props.theme.title === 'light'
        ? props.theme.colors.black
        : props.theme.colors.label};
    font-weight: bold;
  }
`;

export const Button = styled.div`
  display: flex;
  width: 40%;
  height: 150%;
  color: white;
  text-transform: uppercase;
  border-radius: 10px;
  border: 1px solid ${(props) => props.color || props.theme.colors.label};
  font-weight: bold;
  font-size: 11px;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.color || props.theme.colors.label};
  cursor: pointer;
  transition: background-color 0.3s;
  font-size: 18px;

  :hover {
    background: ${(props) => props.theme.colors.card};
    border: 1px solid ${(props) => props.color};
    color: ${(props) => props.color};
  }
`;

export const Line = styled.div`
  justify-content: space-between;
  display: flex;
`;

export const Text = styled.div`
  display: flex;
  justify-content: center;
  font-weight: 500;
  font-size: 24px;
`;

export const Temperature = styled.label`
  color: ${(props) => props.color};
  font-size: 14px;
`;

export const ButtonLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 0 0 0 17px;

  #red {
    width: 50px;
    height: 16px;
    background: ${(props) => props.theme.colors.red};
    margin: 0 15px 0 0;
    border-radius: 10px;
  }

  #orange {
    width: 50px;
    height: 16px;
    background: ${(props) => props.theme.colors.orange};
    border-radius: 10px;
  }
`;

export const UserContainer = styled.div`
  display: flex;
  width: 65px;
  height: 32px;
  align-items: center;
  justify-content: flex-start;
  border-radius: 10px;
  background: ${(props) =>
    props.theme.title === 'light'
      ? props.status === 'resolvido'
        ? props.theme.colors.green
        : props.status === 'resolvendo'
        ? props.theme.colors.disabled
        : props.theme.colors.white
      : props.status === 'resolvido'
      ? props.theme.colors.green
      : props.status === 'resolvendo'
      ? props.theme.colors.disabled
      : 'transparent'};
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: ${(props) => (props.weight ? props.weight : 600)};
  color: ${(props) => (props.color ? props.color : props.theme.colors.label)};
  padding-right: ${(props) => (props.padding ? props.padding : "0px")};
`;
